(() => {
  if (customElements.get('ct-cabin-gallery')) return;
  customElements.define('ct-cabin-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) return;
      this.galleryReady = true;
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-ct-photo-thumb]');
        if (!thumb || !this.contains(thumb) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.selectPhoto(thumb);
      });
      this.addEventListener('keydown', (event) => {
        const thumb = event.target.closest('[data-ct-photo-thumb]');
        if (!thumb || !this.contains(thumb)) return;
        if (event.key === ' ') {
          event.preventDefault();
          this.selectPhoto(thumb);
          return;
        }
        const thumbs = Array.from(this.querySelectorAll('[data-ct-photo-thumb]'));
        let index = thumbs.indexOf(thumb);
        if (event.key === 'ArrowRight') index = (index + 1) % thumbs.length;
        else if (event.key === 'ArrowLeft') index = (index - 1 + thumbs.length) % thumbs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = thumbs.length - 1;
        else return;
        event.preventDefault();
        thumbs[index].focus();
        this.selectPhoto(thumbs[index]);
      });
    }
    selectPhoto(thumb) {
      const main = this.querySelector('[data-ct-photo-main]');
      const link = this.querySelector('[data-ct-photo-link]');
      if (!main || !thumb.dataset.imageSrc) return;
      main.setAttribute('srcset', thumb.dataset.imageSrcset || '');
      main.setAttribute('src', thumb.dataset.imageSrc);
      main.setAttribute('alt', thumb.dataset.imageAlt || '');
      for (const dimension of ['width', 'height']) {
        const value = thumb.dataset[dimension === 'width' ? 'imageWidth' : 'imageHeight'];
        if (Number(value) > 0) main.setAttribute(dimension, value);
        else main.removeAttribute(dimension);
      }
      if (link) link.setAttribute('href', thumb.getAttribute('href'));
      this.querySelectorAll('[data-ct-photo-thumb]').forEach((item) => {
        const selected = item === thumb;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      const count = this.querySelector('[data-ct-photo-count]');
      if (count) count.textContent = thumb.dataset.photoNumber;
    }
  });
})();
